export default __webpack_public_path__ + "static/media/Linkedin-Support.025bd33c.png";